(function () {
  "use strict";

  const module = angular.module("uwAgenda.login");

  /* main controller for LOGIN */
  module.controller("LoginController", [
    "$rootScope",
    '$uibModal',
    "$filter",
    "$location",
    "AuthenticationService",
    "TermsAndConditionsPatchDto",
    "UserService",
    "$state",
    '$window',
    "languages",
    "Alert",
    "SharedAgendaService",
    "StartPageEnum",
    "WebsocketService",
    "AdministrationService",
    "HelperService",
    "UserContactinfoType",
    "ProgramInfoService",
    "CallsService",
    '$http',
    '$translate',
    'ViewsService',
    'ContactInfoService',
    'AppConfig',
    '$localStorage',
    function (
      $rootScope,
      $uibModal,
      $filter,
      $location,
      AuthenticationService,
      TermsAndConditionsPatchDto,
      UserService,
      $state,
      $window,
      languages,
      Alert,
      SharedAgendaService,
      StartPageEnum,
      WebsocketService,
      AdministrationService,
      HelperService,
      UserContactinfoType,
      ProgramInfoService,
      CallsService,
      $http,
      $translate,
      ViewsService,
      ContactInfoService,
      AppConfig,
      $localStorage
    ) {
      /* jshint validthis:true */
      var vm = this;

      run();

      return;

      function run() {
        // list of languages -> passed to language-directive
        vm.languages = [];
        // credentials

        vm.loggedInTroughCorilusPassport = false;

        // logged in ?
        vm.loggedIn = false;

        vm.remember = false;

        // function
        vm.login = login;

        vm.showIPAddress = false;
        vm.IPAddress = "";

        vm.useCredentials = false;

        vm.doUseCredentials = function () {
          vm.useCredentials = true;
        };

        vm.selectAccount = false;
        vm.accountsLinkedToCorilusPassport = [];
        vm.noAccountsFound = false;
        
        vm.tempCorilusPassportToken = null;

        vm.loginViaCorilusPassportClickEvent = function () {
          const clientId = `${AppConfig.clientId}`;
          const redirectUri = encodeURIComponent(`${AppConfig.redirectUri}`);
          const authUrl = AppConfig.authUrl;

          HelperService.GenerateRedirectionUrl(authUrl, clientId, redirectUri, "id_token")
        };

        vm.copyIPAddress = function () {
          HelperService.copyTextToClipboard(vm.IPAddress);
          const confirmation = $translate.instant('value_copied', {value: vm.IPAddress});
          Alert.info(confirmation);
        }

        // unblock page-blocking
        App.unblockUI();

        // list of languages -> passed to language-directive
        vm.languages = languages;

        // Called from the template when the user picks one of the linked accounts
        vm.loginWithSelectedAccount = function (account) {
          loginViaCorilusPassport(vm.corilusPassportToken, account.id);
          vm.corilusPassportToken = null;
        };

        // Automatically log in if possible

        const loginCredentialsFromQueryParams = tryParseLoginCredentialsFromQueryParams();
        // Logging in via credentials in the query params (probably used by Voxtron)
        if (loginCredentialsFromQueryParams.success) {
          vm.username = loginCredentialsFromQueryParams.username;
          vm.password = loginCredentialsFromQueryParams.password;
          loginWithCredentials(vm.username, vm.password);

          // clean
          delete $localStorage.Remember;
          return;
        }

        // If we have a Corilus Passport token then either
        // - We clicked the login with Corilus Passport button on the login page and got redirected back with the token -> then we should log in with that token
        // - We came from the Corilus Passport linking page after logging in using credentials -> then we should link that Corilus Person ID to that user and then log in using that token
        const corilusPassportToken = AuthenticationService.getCorilusPassportIdToken();
        if (corilusPassportToken) {
          loginWithCorilusPassportIdToken(corilusPassportToken);
          return;
        }

        if ($localStorage.Remember) {
          // if remember is set -> automatic login (if it was no logout before)

          // currently logged out ? -> don't login again
          if (AuthenticationService.ManualLogOut === true) {
            // actually clean up the credentials too
            delete $localStorage.Remember;
            return;
          }

          vm.username = $localStorage.Remember.username;
          vm.password = $localStorage.Remember.password;
          vm.remember = true;
          vm.useCredentials = true;
          loginWithCredentials(vm.username, vm.password);
        }

        return;

        function tryParseLoginCredentialsFromQueryParams() {
          const path = $location.search();
          const userNameParamEncoded = path && path["dXNlcm5hbWU="];
          const passwordParamEncoded = path && path["cGFzc3dvcmQ="];

          if (userNameParamEncoded && passwordParamEncoded) {
            const username = atob(userNameParamEncoded);
            const password = atob(passwordParamEncoded);
            return {success: true, username, password};
          }

          return {success: false, username: null, password: null};
        }

        function loginWithCorilusPassportIdToken(corilusPassportToken) {
          const temporaryCorilusLinkingData = retrieveCorilusPassportLinkerDataFromSessionStorageAndClear();
          if (temporaryCorilusLinkingData) {
            linkCorilusPersonIdToUserAndLogin(temporaryCorilusLinkingData, corilusPassportToken);
          } else {
            lookForUsersWithCorilusPassport(corilusPassportToken);
          }

          return;

          function linkCorilusPersonIdToUserAndLogin(temporaryCorilusLinkingData, corilusPassportToken) {
            AuthenticationService.setAuthenticationHeader(temporaryCorilusLinkingData.api_token);
            linkCorilusPersonIdByUserId(temporaryCorilusLinkingData.id, corilusPassportToken, () => {
              loginViaCorilusPassport(corilusPassportToken, temporaryCorilusLinkingData.id);
            });
          }
        }

        function lookForUsersWithCorilusPassport(corilusPassportToken) {
          UserService
            .getUsersWithCorilusPassport(corilusPassportToken)
            .then(users => {
              if (users && users.length === 0) {
                vm.noAccountsFound = true;
              } else if (users.length === 1) {
                loginViaCorilusPassport(corilusPassportToken, users[0].id);
              } else if (users.length > 1) {
                vm.selectAccount = true;
                vm.loggedInTroughCorilusPassport = true;
                vm.accountsLinkedToCorilusPassport = users;
                vm.corilusPassportToken = corilusPassportToken;
              }
            });
        }

        function loginViaCorilusPassport(idToken, userId) {
          vm.loggedInTroughCorilusPassport = true;
          vm.loggedIn = true;
          AuthenticationService
            .loginViaCorilusPassport(idToken, userId)
            .then(function (loggedInUser) {
                /// user is only allowed to log in if he has his own agenda or any agendas have been successfully shared with him (RightConfiguration must be active)
                if (!loggedInUser.hasAgendaAccess) {
                  Alert.warning($translate.instant('no_access_to_agenda'));
                  vm.loggedIn = false;
                  return;
                }
                
                // clean up credentials because they shouldn't be used anymore after logging in with Corilus Passport
                delete $localStorage.Remember;

                // Set Correct Language (From Backend - saved at user - not from login)
                AdministrationService.setLanguage(
                  $filter("filter")(vm.languages, {id: loggedInUser.language}, true)[0]
                );

                SharedAgendaService.setLoggedInUserData({
                  username: loggedInUser.userName,
                  firstName: loggedInUser.firstName,
                  lastName: loggedInUser.lastName,
                  id: loggedInUser.id,
                  roles: loggedInUser.roles.split(","),
                  hasAgendaAccess: loggedInUser.hasAgendaAccess,
                  licenceId: loggedInUser.licenceId,
                });

                AuthenticationService.saveRolesOfLoggedInUserInRootScope();
                AuthenticationService.setAuthenticationHeader(loggedInUser.api_token);

                // check terms and conditions
                if ($rootScope.isMainuser && !loggedInUser.termsAndConditionsAccepted) {
                  showTermsAndConditionsModal(loggedInUser);
                } else {
                  connectAndOpenAgendas(loggedInUser);
                }
              },
              function (error) {
                vm.loggedIn = false;
                vm.loggedInTroughCorilusPassport = false;
                getCurrentIPAddress();
              }
            );
        }
      }

      function loginWithCredentials(username, password) {
        AuthenticationService
          .login(username, password)
          .then(function (loggedInUser) {
              /// user is only allowed to log in if he has his own agenda or any agendas have been successfully shared with him (RightConfiguration must be active)
              if (!loggedInUser.hasAgendaAccess) {
                Alert.warning($translate.instant('no_access_to_agenda'));
                vm.loggedIn = false;
                return;
              }

              // Set Correct Language (From Backend - saved at user - not from login)
              AdministrationService.setLanguage(
                $filter("filter")(vm.languages, {id: loggedInUser.language}, true)[0]
              );

              // if remember -> save credentials in localstorage -> next time -> automatic login
              if (vm.remember) {
                // clean
                delete $localStorage.Remember;
                // store data in storage
                $localStorage.Remember = {
                  username: vm.username,
                  password: vm.password
                };
              } else {
                // delete remember
                delete $localStorage.Remember;
              }

              // the user is only authorized to link their Corilus Passport thus is redirected there.
              const role = loggedInUser.roles.split(",")[0];
              if (role === 'CorilusPassportLinker') {
                storeCorilusPassportLinkerDataTokenInSessionStorage(loggedInUser);
                $state.go("LinkCorilusPassport");
                return;
              }

              SharedAgendaService.setLoggedInUserData({
                username: loggedInUser.userName,
                firstName: loggedInUser.firstName,
                lastName: loggedInUser.lastName,
                id: loggedInUser.id,
                roles: loggedInUser.roles.split(","),
                hasAgendaAccess: loggedInUser.hasAgendaAccess,
                licenceId: loggedInUser.licenceId,
              });

              AuthenticationService.saveRolesOfLoggedInUserInRootScope();
              AuthenticationService.setAuthenticationHeader(loggedInUser.api_token);

              if (vm.tempCorilusPassportToken) {
                linkCorilusPersonIdByUserId(loggedInUser.id, vm.tempCorilusPassportToken);
                vm.tempCorilusPassportToken = null;
              }

              // check terms and conditions
              if ($rootScope.isMainuser && !loggedInUser.termsAndConditionsAccepted) {
                showTermsAndConditionsModal(loggedInUser);
              } else {
                connectAndOpenAgendas(loggedInUser);
              }
            },
            function (error) {
              vm.loggedIn = false;
              getCurrentIPAddress();
            }
          );
      }

      function linkCorilusPersonIdByUserId(userId, corilusPassportToken, callback) {
        UserService.setCorilusPersonId(userId, corilusPassportToken)
          .then(function () {
            Alert.success($translate.instant('corilus_passport_link_success'));
            if (callback) {
              callback();
            }
          })
          .catch(function () {
            Alert.warning($translate.instant('corilus_passport_link_fail'));
          });
      }

      function storeCorilusPassportLinkerDataTokenInSessionStorage(data) {
        sessionStorage.setItem('temporaryCorilusLinkingData', JSON.stringify(data));
      }

      function retrieveCorilusPassportLinkerDataFromSessionStorageAndClear() {
        const data = JSON.parse(sessionStorage.getItem('temporaryCorilusLinkingData'));
        sessionStorage.removeItem('temporaryCorilusLinkingData');
        return data;
      }

      // log in user
      function login() {
        vm.loggedIn = true;
        vm.showIPAddress = false;

        if (!vm.username || !vm.password) {
          Alert.warning("Please fill in Username and Password");
          vm.loggedIn = false;
          return;
        }

        // authenticate
        loginWithCredentials(vm.username, vm.password);
      }

      function connectAndOpenAgendas(loggedInUser) {
        // message
        Alert.success($translate.instant('hello_login') + ' ' + loggedInUser.firstName);
        // Websocket connection
        WebsocketService.connect(
          $rootScope.isRingfoon,
          loggedInUser.webSocketServer
        );

        var startPage = loggedInUser.startPage;

        // register program info screen
        ProgramInfoService.registerWebsocket();

        SharedAgendaService.loadAgendas().then(function (result) {
          // register WebSocket
          SharedAgendaService.registerWebsocket();

          //// helper service data
          // contact-info-types
          AdministrationService.contactinfotypes().then(function (result) {
            ContactInfoService.data.contactinfotypes = [];
            // make right type object
            var i = 0;
            var len = result.length;
            for (i = 0; i < len; i++) {
              var cit = new UserContactinfoType();
              cit.extend(result[i]);
              // add
              ContactInfoService.data.contactinfotypes.push(cit);
            } // for
          });

          // phonemasks
          AdministrationService.phonemasks().then(function (result) {
            HelperService.data.phonemasks = result;
          });

          // countries
          AdministrationService.countries().then(function (result) {
            HelperService.data.countries = result;
            HelperService.data.countriesWithCallingCodes = $filter(
              "filter"
            )(result, {callingCode: ""});
          });

          // load all views for the current user, 
          // if the current user is an operator: load the current agenda owner's views 
          var viewOwnerId = $rootScope.isRingfoon
            ? SharedAgendaService.currentUser().id
            : loggedInUser.id;

          ViewsService.getViewsForOwner(viewOwnerId)
            .then(function () {
              // do we need to load user-data for ringfoon info panel ?
              if ($rootScope.isRingfoon) {
                // register websocket for incoming calls
                CallsService.registerWebsocket();

                // ringfoon info -> user data of selected user/owner is required
                SharedAgendaService.loadOwner(
                  SharedAgendaService.currentUser().id
                ).then(function (result) {
                  // go to main page
                  showView(startPage);
                });
              } // if
              else {
                // go to main page
                showView(startPage);
              } // else
            });
        });
      }

      function getCurrentIPAddress() {
        AdministrationService.getIPAddress()
          .then(function (ipAddress) {
            vm.IPAddress = ipAddress;
            vm.showIPAddress = true;
          });
      }

      // show Terms and conditions
      function showTermsAndConditionsModal(loggedInUser) {

        $rootScope.saveAndCloseTermsAndConditionsModal = () => saveAndCloseTermsAndConditionsModal(loggedInUser);
        $rootScope.closeTermsAndConditionsModal = closeTermsAndConditionsModal;
        // open modal for accepting terms and Conditions
        vm.modalInstance = $uibModal.open({
          backdrop: 'static',
          keyboard: false,
          animation: true,
          templateUrl: '/app/login/templates/terms-and-conditions.template.html',
          scope: $rootScope,
          size: 'xl'
        });

        vm.modalInstance.result.then(() => {
          delete $rootScope.saveAndCloseTermsAndConditionsModal;
          delete $rootScope.closeTermsAndConditionsModal;
        });

        function closeTermsAndConditionsModal() {
          if (vm.modalInstance !== null) {
            vm.modalInstance.dismiss();
          }

          vm.loggedIn = false;
          Alert.warning($translate.instant('please_accept_termsandconditions'));
        }

        function saveAndCloseTermsAndConditionsModal(loggedInUser) {
          if (vm.modalInstance !== null) {
            vm.modalInstance.dismiss();
          }

          let termsAndConditionsPatchCommand = new TermsAndConditionsPatchDto(loggedInUser.agendaId, true);
          // update user
          UserService.updateUserTermsAndConditions(loggedInUser.id, termsAndConditionsPatchCommand).then(
            function (result) {
              // continue with login
              connectAndOpenAgendas(loggedInUser);
            }
            ,
            function () {
              vm.loggedIn = false;
            });

        }
      }

      // go to first view
      function showView(startPage) {
        // get user's startpage if he has one selected, otherwise use default value
        if (typeof startPage === "undefined" || startPage === null) {
          startPage = StartPageEnum.AgendaDay.value;
        }

        // check if user has rights to access the saved startpage - if not, redirect him to a default start page he is allowed to access
        // Superadmin, Ringfoon operator admin, Main user and Subuser admin can access all pages
        if (
          !$rootScope.isMainuser &&
          !$rootScope.isRingfoonOperatorAdmin &&
          !$rootScope.isRingfoonAdmin &&
          !$rootScope.isSubuserAdmin
        ) {
          // Collegues can only access agenda-pages
          if (
            $rootScope.isColleague &&
            startPage !== StartPageEnum.AgendaDay.value &&
            startPage !== StartPageEnum.AgendaWeek.value
          ) {
            startPage = StartPageEnum.AgendaDay.value;
          }
          // // user is a restricted user and cannot access the user or agendasettings pages
          // else if (startPage === StartPageEnum.User.value || startPage === StartPageEnum.AgendaSettings.value) {
          //     startPage = StartPageEnum.DayTask.value;
          // }
        }

        switch (startPage) {
          case StartPageEnum.UrgentTodo.value:
            $state.go("Home.Tasks", {isToDo: "true", all: false});
            break;
          case StartPageEnum.User.value:
            $state.go("Home.Users", {all: false});
            break;
          case StartPageEnum.AgendaDay.value:
            $state.go("Home.Agenda_Day", {today: true});
            break;
          case StartPageEnum.AgendaWeek.value:
            $state.go("Home.Agenda_Week");
            break;
          case StartPageEnum.AgendaSettings.value:
            $state.go("Home.Agendasettings.General");
            break;
        }
      }
    },
  ]);
})();
